/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Page_Tutorials_TitleInputs */

const en_cad_page_tutorials_title = /** @type {(inputs: Cad_Page_Tutorials_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CADCraft Tutorial: Basic Commands for Beginners`)
};

/**
* | output |
* | --- |
* | "CADCraft Tutorial: Basic Commands for Beginners" |
*
* @param {Cad_Page_Tutorials_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_page_tutorials_title = /** @type {((inputs?: Cad_Page_Tutorials_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Page_Tutorials_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_page_tutorials_title(inputs)
});
export { cad_page_tutorials_title as "cad.page.tutorials.title" }